// extracted by mini-css-extract-plugin
export default {"container":"panelrewards_container__u7Pip","buttonContainer":"panelrewards_buttonContainer__RGAyL","selected":"panelrewards_selected__WlaeS"};